import type { Song } from "../types";

/** Estrellita / Twinkle Twinkle Little Star (traditional, public domain). */
export const twinkleTwinkle: Song = {
  id: "twinkle-twinkle",
  title: "Twinkle Twinkle Little Star",
  bpm: 100,
  instrument: "piano",
  notes: [
    { key: "C4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "A4", beats: 1 },
    { key: "A4", beats: 1 },
    { key: "G4", beats: 2 },
    { key: "F4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 2 },
    { key: "G4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 2 },
    { key: "G4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 2 },
    { key: "C4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "A4", beats: 1 },
    { key: "A4", beats: 1 },
    { key: "G4", beats: 2 },
    { key: "F4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 2 },
  ],
};
